import { SignUpUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

export const createUser = () => {
  return new SignUpUseCase('/index/firstStep', makeAxiosHttpClient())
}
